module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-Light-fe2ab80b34c6a83f02f66a407d2ca021.woff2";